import React from 'react';

const GameLiveCasion = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2 8C2 6.34315 3.34315 5 5 5H19C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H5C3.34315 19 2 17.6569 2 16V8Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.26584 14.0104C8.26584 14.2808 8.04664 14.5 7.77624 14.5H5.91064C5.35836 14.5 4.91064 14.0523 4.91064 13.5V10.0324C4.91064 9.73616 5.1508 9.496 5.44704 9.496C5.74329 9.496 5.98344 9.73616 5.98344 10.0324V13.5208H7.77624C8.04664 13.5208 8.26584 13.74 8.26584 14.0104Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.93501 13.9636C9.93501 14.2598 9.69485 14.5 9.39861 14.5C9.10236 14.5 8.86221 14.2598 8.86221 13.9636V10.0324C8.86221 9.73616 9.10236 9.496 9.39861 9.496C9.69485 9.496 9.93501 9.73616 9.93501 10.0324V13.9636Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.7369 13.8461C13.603 14.2372 13.2353 14.5 12.8218 14.5C12.4084 14.5 12.0406 14.2372 11.9067 13.8461L10.6572 10.1972C10.5394 9.8535 10.7949 9.496 11.1582 9.496C11.3863 9.496 11.5888 9.64202 11.6608 9.85844L12.8434 13.4128L13.9856 9.86214C14.0558 9.64395 14.2588 9.496 14.488 9.496C14.8501 9.496 15.1046 9.85223 14.9873 10.1947L13.7369 13.8461Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.3537 14.0356C19.3537 14.2921 19.1458 14.5 18.8893 14.5H16.7177C16.1654 14.5 15.7177 14.0523 15.7177 13.5V10.496C15.7177 9.94372 16.1654 9.496 16.7177 9.496H18.8533C19.1098 9.496 19.3177 9.70392 19.3177 9.9604C19.3177 10.2169 19.1098 10.4248 18.8533 10.4248H16.7905V11.512H18.3925C18.649 11.512 18.8569 11.7199 18.8569 11.9764C18.8569 12.2329 18.649 12.4408 18.3925 12.4408H16.7905V13.5712H18.8893C19.1458 13.5712 19.3537 13.7791 19.3537 14.0356Z",
      fill: "white"
    }
  )
);

export { GameLiveCasion };
//# sourceMappingURL=GameLiveCasion.js.map
